import React from 'react'

const SuccessCheck = () => {
  return (
	  <div className="success-circle">
		<div className="success-check" />
	  </div>
  )
}

export default SuccessCheck
